import { IOfficialDiaryPagedRequest } from '../../../../model/sdp/official-daily/request/official-diary-paged-request';

export type OfficialDiarySearchState = {
  parameters: IOfficialDiaryPagedRequest;
  searchTrigger: number;
};

export enum ACTION_TYPES {
  updateParameter = 'updateParameter',
  triggerSearch = 'triggerSearch',
}

export const OfficialDiarySearchReducer = (state: OfficialDiarySearchState, action: any): OfficialDiarySearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.triggerSearch:
      return {
        ...state,
        searchTrigger: state.searchTrigger + 1,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
